/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Tag_Term_LabelInputs */

const en_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag Term`)
};

const fr_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terme du tag`)
};

const de_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag-Begriff`)
};

const it_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine tag`)
};

const ru_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Термин-тег`)
};

const es_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Término de etiqueta`)
};

const zh_cn2_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签词`)
};

const ja_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ用語`)
};

const hi_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग शब्द`)
};

const pt_pt2_tags_manager_tag_term_label = /** @type {(inputs: Tags_Manager_Tag_Term_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termo de etiqueta`)
};

/**
* | output |
* | --- |
* | "Tag Term" |
*
* @param {Tags_Manager_Tag_Term_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_tag_term_label = /** @type {((inputs?: Tags_Manager_Tag_Term_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Tag_Term_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_tag_term_label(inputs)
	if (locale === "de") return de_tags_manager_tag_term_label(inputs)
	if (locale === "it") return it_tags_manager_tag_term_label(inputs)
	if (locale === "ru") return ru_tags_manager_tag_term_label(inputs)
	if (locale === "es") return es_tags_manager_tag_term_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_tag_term_label(inputs)
	if (locale === "ja") return ja_tags_manager_tag_term_label(inputs)
	if (locale === "hi") return hi_tags_manager_tag_term_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_tag_term_label(inputs)
	return en_tags_manager_tag_term_label(inputs)
});